export function AppNotFound() {
	return (
		<main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-stone-50 px-6 text-center text-stone-800">
			<p className="text-sm font-medium uppercase tracking-[0.24em] text-stone-500">
				TrotroWays
			</p>
			<h1 className="text-3xl font-semibold tracking-tight">Page not found</h1>
			<p className="max-w-md text-sm leading-6 text-stone-600">
				The page you requested does not exist or may have moved.
			</p>
			<a
				className="rounded-full bg-stone-900 px-5 py-3 text-sm font-medium text-stone-50 transition hover:bg-stone-700"
				href="/"
			>
				Return to route planner
			</a>
		</main>
	);
}